import "./Cart.module.css";
import Header from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import Footer from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <Header />
      <CartContent />
      <Footer />
    </div>;
}